import { render, staticRenderFns } from "./Template102Lembrete.vue?vue&type=template&id=1189408b"
import script from "./Template102Lembrete.vue?vue&type=script&lang=js"
export * from "./Template102Lembrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1189408b')) {
      api.createRecord('1189408b', component.options)
    } else {
      api.reload('1189408b', component.options)
    }
    module.hot.accept("./Template102Lembrete.vue?vue&type=template&id=1189408b", function () {
      api.rerender('1189408b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Template102Lembrete.vue"
export default component.exports